import { render, staticRenderFns } from "./Advices.vue?vue&type=template&id=4484b248&scoped=true"
import script from "./Advices.vue?vue&type=script&lang=js"
export * from "./Advices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484b248",
  null
  
)

export default component.exports